/**
 * Config
 * ------
 * High level general purpose variables and settings
 */

// global elements
window.$b = $('body');
window.$w = $(window);

// app variables and functions
window.app = {
	breakpoints : {
	    xs: 0,
	    md: 768,
	    lg: 1025,
	    xl: 1536
	}
};